import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  transform: "matrix(.30441 0 0 .19528 -4.0986 -9.6401)",
  d: "m17.375 49.366-3.9113 6.7745h2.6075v6.7745h-2.6075l3.9113 6.7745 3.9113-6.7745h-2.6075v-6.7745h2.6075z",
  "stroke-width": "1.0852"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    width: "9",
    height: "15",
    version: "1.1",
    viewBox: "0 0 2.3812 3.9688",
    xmlns: "http://www.w3.org/2000/svg",
    fill: _ctx.color
  }, _hoisted_3, 8, _hoisted_1))
}